export const ru = {
  LANGUAGES: {
    TITLE: 'Языки',
    English: 'Английский',
    Russian: 'Русский',
    Ukrainian: 'Украинский',
    German: 'Немецкий',
  },
  PAGES: {
    HOME: {
      SEARCH: {
        HINT: 'Напиши какую историю, мир, персонажа ты хочешь найти',
      },
      TRENDING: {
        TITLE: 'Популярные за последние 14 дней',
      },
    },
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Ваши предыдущие чаты',
      SEARCH_BY_NAME: 'Поиск по названию',
      PLACEHOLDER_TITLE: 'По вашему запросу ничего не найдено',
      PLACEHOLDER_TEXT: 'Попробуйте изменить параметры поиска',
      EMPTY: {
        TITLE: 'У вас пока нет активных чатов',
        TEXT: 'Выберите приключение из десятков тысяч или создайте свое',
        CREATE_CHATBOT: 'Создать чат-бота',
        GO_TO_CATALOG: 'Перейти в каталог',
      },
    },
    SMART_SEARCH: {
      HEADING: 'Найди своё приключение',
      SEARCH_PLACEHOLDER: 'Поиск нового приключения',
      TOOLTIP: {
        ENABLED: {
          TITLE: 'Умный поиск: включён',
          TEXT: 'Семантический поиск по смыслу',
        },
        DISABLED: {
          TITLE: 'Умный поиск: выключен',
          TEXT: 'Простое совпадение по тексту',
        },
        NOT_AVAILABLE: {
          TITLE: 'Ошибка голосового ввода',
          TEXT: 'Проверьте настройки доступа в браузере или работоспособность устройства ввода',
        },
      },
      LOADER_STEPS: {
        0: 'Начинаем поиск...',
        1: 'Открываем картотеку персонажей......',
        2: 'Отбираем подходящие типажи...',
        3: 'Уговариваем их показаться...',
        4: 'Отсеиваем скучных, еще чуть-чуть...',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Подписка',
      PICK_THE_PLAN: 'Выберите план или купите токены',
      UPGRADE_YOUR_EXPERIENCE: 'Улучшите свой опыт и раскройте воображение с премиум-функциями',
      BUY_TOKENS: 'Купить токены',
      APPLY: 'Применить',
      PROMO_CODE: 'Промокод',
      PLANS: 'Планы',
      TOKENS: 'Токены',
      CODE_APPLIED: 'Код применен',
      PROMOTIONAL_CODE: 'Введите промокод',
      DISCOUNT: '+{{discount}}% к пополнению',
      COMPARE_CAICHAT_FEATURE: 'Сравните функции {{brandShort}}',
      NO_ADS: 'Без рекламы',
      SKIP_QUEUES: 'Без очередей',
      CONTEXTUAL_MEMORY_4K: 'Контекстная память до 4K токенов (примерно 42 сообщения)',
      ACCESS_MEMORY_MANAGER: 'Доступ к менеджеру памяти',
      CUSTOM_PERSONAS_10: 'До 10 пользовательских персон',
      CONTEXTUAL_MEMORY_8K: 'Контекстная память до 8K токенов (примерно 84 сообщения)',
      SEMANTIC_MEMORY_2: 'Семантическая память 2.0: автоматическое сохранение и использование воспоминаний',
      EXTENDED_RESPONSES: 'Расширенные ответы до 300 токенов',
      IMAGE_GENERATION: 'Генерация изображений в диалоге',
      ACCESS_AI_MODELS: 'Доступ к дополнительным моделям ИИ',
      CUSTOM_PERSONAS_50: 'До 50 пользовательских персон',
      CONTEXTUAL_MEMORY_16K: 'Контекстная память до 16K токенов (примерно 168 сообщений)',
      PRIORITY_GENERATION: 'Приоритет в генерации ответов',
      ACCESS_ADVANCED_MODELS: 'Доступ к продвинутым моделям ИИ',
      IMAGE_GENERATION_ALL: 'Генерация изображений для всех персонажей, включая приватных',
      TEXT_TO_SPEECH: 'Функция преобразования текста в речь (голосовые ответы)',
      CUSTOM_PERSONAS_100: 'До 100 пользовательских персон',
      HAVE_PROMO_CODE: 'У вас есть промокод?',
      APPLY_PROMO_CODE: 'Примените промокод и получите бонус при покупке токенов или подписки',
      TOKENS_PACK: {
        POPULAR: 'Популярный',
        SPECIAL_SALE: 'Специальная распродажа',
        STANDARD_PACKS: 'Стандартные пакеты',
        SPECIAL_OFFER: 'Специальное предложение',
      },
    },
    MY_PROFILE: {
      BACK: 'Назад',
      MY_PROFILE: 'Мой профиль',
      SETTINGS: 'Настройки',
      LOG_OUT: 'Выйти',
      TITLE: 'Держитесь крепче!\nВаша персональная панель управления готовится!',
      TEXT: 'Наша команда усердно работает над тем, чтобы создать для вас максимально удобный личный кабинет.\nСкоро вы сможете просматривать подробную статистику, отслеживать расходы и доходы и многое другое.\nСледите за новостями!',
      TABS: {
        REFERRAL: 'Реферальная программа',
        MONETIZATION: 'Монетизация',
        PURCHASE_HISTORY: 'История покупок',
        BALANCE_HISTORY: 'История баланса',
        AI_MODELS: 'AI Модели',
      },
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'У вас еще нет персон.',
      PLACEHOLDER_2: 'Создайте новую.',
      CREATE_PERSONA: 'Создать новую персону',
    },
    CREATE_PERSONA: {
      PERSONA: 'Персона',
      NAME_PLACEHOLDER: 'Введите имя вашей персоны',
      DESCRIPTION: 'Описание',
      DESCRIPTION_PLACEHOLDER: 'Как бы ваша персона описала себя?',
      DESCRIPTION_INFO: 'Используется только в ваших разговорах для предоставления контекста ИИ. Будьте лаконичны (1-2 предложения).',
      VISIBILITY: 'Видимость',
      PUBLIC: 'Публичная',
      PRIVATE: 'Приватная',
      CHECKBOX: 'Установить как персону по умолчанию',
      ALREADY_DEFAULT: 'Уже персона по умолчанию',
      NAME: 'Имя персоны',
      SUCCESSFULLY_CREATED: 'Персона успешно создана',
      SUCCESSFULLY_UPDATED: 'Персона успешно обновлена',
      NO_SPACE_FOR_NEW_PERSONAS: 'Вы не сможете создавать новых персон, пока не освободите место',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'Вы еще не создали ни одного чат-бота!',
      DO_IT_NOW: 'Сделайте это сейчас!',
    },
    MY_GAMES: {
      TITLE: 'Мои Игры',
      SUBTITLE: 'Управление игровыми расширениями',
      SEARCH_PLACEHOLDER: 'Поиск игр...',
      LOADING: 'Загрузка...',
      NO_GAMES: 'Вы ещё не создали ни одной игры',
      NO_SEARCH_RESULTS: 'Игры не найдены',
      WORKFLOWS: '{{ count }} сценариев',
      STORAGES: '{{ count }} хранилищ',
      LOADING_EXTENSION: 'Загрузка игры...',
      LOADING_WORKFLOW: 'Загрузка сценария...',
      STARTING_GAME: 'Запуск...',
      FINISHED: 'Завершено',
      RESTART: 'Играть снова',
      RETRY: 'Повторить',
      ERROR: 'Ошибка',
      LOAD_FAILED: 'Не удалось загрузить',
      INVALID_ID: 'Неверный ID игры',
      NO_WORKFLOW: 'Сценарий не найден',
      NO_NODES: 'Сценарий не содержит узлов',
      JUST_NOW: 'только что',
      MINUTES_AGO: '{{ count }} мин. назад',
      HOURS_AGO: '{{ count }} ч. назад',
      DAYS_AGO: '{{ count }} д. назад',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'По вашему запросу ничего не найдено',
      FILTERS: 'Попробуйте изменить параметры поиска или создайте собственного чатбота',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'У этого пользователя сейчас нет чатботов',
      TRY_LATTER: 'Попробуйте зайти позже',
    },
    FAVORITES: {
      NO_FAVORITES: 'У вас пока нет чатботов в избранном',
      GO_AND_ADD: 'Перейдите в каталог и добавьте чатботов в избранное, нажав на кнопку',
      PURCHASE_HISTORY: 'История покупок',
      BALANCE_HISTORY: 'История баланса',
      MONETIZATION: 'Монетизация',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Загрузка',
      MODEL_AND_PROMPT: 'Выберите модель ИИ и ее поведение',
      IMPORT_CHATBOT: 'Импортировать чат-бота',
      CHATBOT_AVATAR: 'Аватар чат-бота',
      CHATBOT_NAME: 'Имя чат-бота',
      CHATBOT_DESCRIPTION: 'Описание чат-бота',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Загрузить изображение для чат-бота',
      CREATE_CHATBOT: 'Создать чат-бота',
      START_CHAT: 'Начать чат',
      SAVE_CHANGES: 'Сохранить изменения',
      AGREEMENT_TEXT: 'Я прочитал и согласен с',
      COMMUNITY_GUIDELINES: 'Правилами сообщества',
      MESSAGE_COST: 'Стоимость сообщения',
      GENDER: 'Пол',
      VISIBILITY: 'Видимость',
      ADD_TAGS: 'Добавить теги',
      SEARCH_TAGS: 'Поиск тегов',
      NAME_PLACEHOLDER: 'Введите имя чат-бота',
      DESCRIPTION_PLACEHOLDER:
        'Краткое описание чат-бота, которое будет отображаться в каталоге и превью.<br><br>Не повлияет на память или поведение.',
      CREATE_NEW_CHATBOT: 'Создать нового чат-бота',
      EDIT_CHATBOT: 'Редактировать чат-бота',
      CHATBOT_PROFILE: 'Профиль чат-бота',
      GUIDE: 'Читать руководство',
      READ_CREATION_GUIDE: 'Прочитайте наше руководство по созданию чат-ботов',
      STATS_TITLE: 'Статистика',
      HAS_BEEN_STARTED: 'Дата начала:',
      USER_MESSAGES: 'Сообщений пользователя:',
      CHARACTER_MESSAGES: 'Сообщений чат-бота:',
      USER_WORDS: 'Слов пользователя:',
      CHARACTER_WORDS: 'Слов чат-бота:',
      FILL_REQUIRED_FIELDS: 'Необходимо заполнить обязательные поля!',
      MALE: 'Мужской',
      FEMALE: 'Женский',
      NON_BINARY: 'Небинарный',
      OTHER: 'Другой',
      NOT_SPECIFIED: 'Не указано',
      PUBLIC: 'Публичный',
      PRIVATE: 'Приватный',
      VISIBLE_TOOLTIP: 'Публичный — виден всем. Приватный — виден только автору этого чат-бота.',
      AI_TOOLTIP:
        'ИИ модель: Программа, обученная понимать и генерировать текст как человек. \n \n Поведение: Стиль повествования, указание ИИ о том, как он должен себя вести',
      NO_ONLY_EMOJI: 'Имя не может состоять только из эмодзи',
      COST_DEPENDS: 'Стоимость зависит от различных параметров: Модель, Поведение, Приветствия, Сценарий.',
      PRICE_1_MESSAGE: 'Цена за 1 сообщение:',
      NOT_AVAILABLE: {
        TITLE: 'Это приватный чат-бот',
        TEXT: 'Вы пытаетесь получить доступ к ссылке на чат-бота, доступ к которому ограничен его автором. Вы не можете просматривать или взаимодействовать с этим чат-ботом.',
        GO_HOME: 'На главную страницу',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Другие боты этого автора',
      SIMILAR_CHATBOTS: 'Похожие боты',
      ACCESS_ONLY_LINK: 'Доступ к нему возможен\n только по ссылке автора.',
      PERSONAL_CHARACTER: 'Это личный персонаж',
      DEFINITION: 'Определение',
      ALLOW_PROXIES: 'Разрешить прокси',
      DEFINITION_DESCRIPTION: 'Пользователи смогут видеть личность и сценарий.',
      ALLOW_PROXIES_DESCRIPTION: 'Пользователи смогут использовать прокси-сервисы для взаимодействия с вашим ботом.',
      ADDITIONAL_SETTINGS: 'Дополнительные настройки',
      SETTINGS: 'Настройки',
      ALLOW_REPLACEMENT: 'Пользовательские модели',
      ALLOW_REPLACEMENT_DESCRIPTION: 'Пользователи смогут использовать личные модели для общения с ботом.',
      SHOW_NOTES_FIRST: 'Показывать первыми',
      SHOW_NOTES_FIRST_DESCRIPTION: 'При открытии чат-бота пользователи сначала увидят ваши авторские заметки, а затем первое сообщение.',
      EDIT: 'Редактировать',
    },
  },
  MODALS: {
    PROMO_CODE: {
      HAVE_PROMO_CODE: 'У вас есть промокод?',
      APPLY_TO_RECEIVE: 'Используйте его, чтобы получить бонус',
      ENTER_CODE: 'Введите промокод',
      CODE_APPLIED: 'Промокод применён',
      APPLY: 'Применить',
      PROMO_BONUS:
        'Бонус промокода: <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">+{{tokens}}</span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="size-4 inline-block"><path d="M12.4137 5.51725H8.63443L12.1379 0H7.72409L3.58618 8.27588H6.84137L3.58618 16L12.4137 5.51725Z" fill="#ff9f32"/></svg> за подписку или {{bonusPercent}}% бонусных токенов к наборам токенов',
      PREV_ACTIVE: 'Вы уже применяли реферальный код ранее',
      VALIDATION_ERROR: 'Промокод должен содержать ровно {{length}} символов и включать только A-Z и 0-9.',
      NO_CODE: 'Реферальный код не найден или неактивен',
    },
    UPGRADE_SUGGESTION: {
      BANNER: 'СПЕШИТЕ!',
      TITLE:
        'Сэкономь <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent">{{percent}}%</span> на Бесконечных историях',
      TEXT: 'Открой умную память, генерацию изображений и более глубокие диалоги',
      PER_YEAR: '/год',
      PER_MONTH: '/мес',
      ENHANCED_MEMORY_TITLE: 'Улучшенная память',
      ENHANCED_MEMORY_DESCRIPTION: 'Ваша история сохраняется целиком, от начала до конца',
      UNLIMITED_IMAGE_GENERATION_TITLE: 'Безлимитная генерация изображений',
      UNLIMITED_IMAGE_GENERATION_DESCRIPTION: 'Создавайте сцены и персонажей без ограничений',
      RICHER_ROLEPLAY_TITLE: 'Более насыщенный ролевой отыгрыш',
      RICHER_ROLEPLAY_DESCRIPTION: 'Глубже истории, более выразительные персонажи',
      UNLOCK: 'УЛУЧШИТЬ МОЮ ИСТОРИЮ — СКИДКА ДО {{percent}} %',
      UNLOCK_MOBILE: 'УЛУЧШИТЬ МОЮ ИСТОРИЮ',
      MAYBE_LATER: 'Возможно позже',
    },
    UNLOCK_VOICEOVER: {
      TITLE: 'Дайте персонажам голос',
      TEXT_1:
        'Наша функция озвучивания доступна только в тарифном плане <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">{{plan}}</span>.',
      TEXT_2:
        'Не просто читайте историю — проживите её. Обновитесь до <span class="font-semibold">{{plan}}</span> и <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">разблокируйте высококачественное озвучивание</span>. Слушайте уникальные <span class="bg-gradient-to-r from-[#F372FF] from-[18.1%] to-[#FFD153] to-[90.98%] bg-clip-text text-transparent font-extrabold">интонации, эмоции и шёпот</span> ваших любимых персонажей, когда они отвечают вам в реальном времени.',
    },
    CHAT_QUERY: {
      WAIT_TITLE: 'Ожидание затянулось',
      WAIT_TIME: 'Примерное время ожидания',
      POSITION: 'Позиция в очереди',
      QUEUE_INFO: 'Мы стремимся обеспечить максимальный комфорт для всех пользователей, поэтому в часы пик может возникать очередь.',
      SUBSCRIPTION_INFO: 'Поддержка через подписку позволяет нам продолжать улучшения, а вы можете общаться без очередей!',
      UPGRADE: 'Пропустите очередь с подпиской',
      CANCEL: 'Отменить генерацию сообщения',
      LESS_THAN_MINUTE: 'Менее минуты',
      ABOUT_MINUTE: 'Примерно минуту',
      ONE_TWO_MINUTES: 'Одна–две минуты',
      SEVERAL_MINUTES: 'Несколько минут',
    },
    MODEL_SETTINGS: {
      TITLE: 'Настройки модели',
      ADVANCED_SETTINGS: 'Расширенные настройки',
      APPLY_SETTINGS: 'Применить настройки',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Сгенерировать фон',
      GENERATE_AVATAR: 'Сгенерировать аватар',
      GENERATE_IMAGE: 'Сгенерировать изображение',
      ENTER_PROMPT: 'Опишите изображение для генерации',
      AGE_ERROR: 'Запрос отклонен: требования безопасности. Персонажи младше 18 лет запрещены.',
      PROMPT_PLACEHOLDER: 'Укажите модель генерации и опишите изображение',
      SAFE_GENERATION: 'Безопасная генерация',
      SAFE_GENERATION_PROFILE_REQUIRED_ERROR:
        'Отключение безопасной генерации доступно только при включенной настройке профиля «Показывать NSFW контент».',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Чат-бот удалён',
      TEXT: 'Этот чат-бот был удалён автором или администратором. Начните общаться с другими ботами прямо сейчас.',
      GO_HOME: 'На главную',
    },
    EMAIL_CONFIRMED: {
      TITLE: 'Ваша почта подтверждена',
      TEXT: 'Ваш аккаунт полностью активирован и готов к работе. Начните прямо сейчас: выберите один из популярных чат-ботов или создайте своего.',
      BUTTON: 'Отлично!',
    },
    AUTH_SESSION_ERROR: {
      TITLE: 'Что-то пошло не так',
      TEXT: 'Не удалось подтвердить вашу авторизацию. Похоже, возникли временные трудности со связью или на нашей стороне. Пожалуйста, обновите страницу или повторите попытку позже.',
      RETRY_BUTTON: 'Попробовать снова',
      RETURN_TO_SIGN_IN_BUTTON: 'Вернуться на вход',
    },
    WELCOME: {
      AGE_AGREE: 'Я подтверждаю, что мне 18 лет или более',
      BOUND_BY: 'Вы соглашаетесь с ',
    },
    GUIDELINES: {
      TITLE: 'Соглашение о правилах сообщества',
      TEXT_1:
        'Для обеспечения позитивного и уважительного общения мы просим вас соблюдать наши правила сообщества, которые включают в себя следующее:',
      TEXT_2:
        'Запрещён любой контент, связанный с незаконными темами, такими как инцест, несовершеннолетние или любая незаконная деятельность.',
      TEXT_3: 'Уважайте других и поддерживайте безопасное пространство для разнообразных обсуждений.',
      TEXT_4: 'Соблюдайте все применимые законы и учитывайте стандарты сообщества.',
      TEXT_5:
        'Продолжая, вы соглашаетесь следовать этим правилам и помогать поддерживать здоровую и уважительную атмосферу. Давайте сделаем общение веселым и уважительным для всех!',
      I_HAVE: 'Я прочитал и буду следовать',
      START_CHATTING: 'Начать чат',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'Доступ к NSFW-контенту',
      TEXT: 'Видимость контента должна быть включена в настройках вашей учетной записи. После включения вы сможете управлять отображением NSFW-контента прямо с главной страницы.',
      GO_TO_SETTINGS: 'Перейти в настройки',
    },
    CHAT_DECRYPT: {
      TITLE: 'Этот чат защищён паролем',
      TEXT: 'Введите пароль для доступа к чату',
      ENCRYPT_PASSWORD: 'Пароль шифрования',
      CONFIRM_ENCRYPT_PASSWORD: 'Подтвердите пароль шифрования',
    },
    CHAT_ENCRYPT: {
      TITLE: 'Сквозное шифрование',
      NOT_ENCRYPTED: 'Ваш чат не зашифрован',
      ENCRYPTED: 'Ваш чат зашифрован',
      TEXT: 'Сообщения и чаты защищены сквозным шифрованием. Третьи лица, включая {{brand}}, не могут читать ваши сообщения.',
      ENTER_LABEL: 'Создайте пароль шифрования, если хотите включить шифрование для чата с чат-ботом.',
      ENABLE: 'Включить шифрование',
      DISABLE: 'Отключить шифрование',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Выберите персонажа:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'AI-модель и системная подсказка',
      TAGS: 'Теги',
      TAGS_PLACEHOLDER: 'Добавьте теги с ключевыми словами для персонажа (максимум 10 тегов)',
      START_CHAT: 'Начать чат',
    },
    PASSWORD_RESET: {
      ENTER_NEW_PASSWORD: 'Введите новый пароль в поля ниже.',
      INVALID_URL: 'Недействительная ссылка. Пожалуйста, запросите сброс пароля снова.',
      APPLY_NEW_PASSWORD: 'Применить новый пароль',
      REQUEST_PASSWORD_RESET: 'Запросить сброс пароля',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Изображения',
      NEGATIVE_PROMPT: 'Негативный промт',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Напишите, что вы не хотите видеть на изображениях',
      STYLE_TITLE: 'Стиль',
      STYLE_ANIME: 'Аниме',
      UNI_STYLE: 'Свободный',
      STYLE_REALISTIC: 'Реализм',
      GENERATION_OF_NSFW: 'Генерация NSFW-изображений',
      GENERATION_OF_NSFW_TOOLTIP: 'Включите, если хотите видеть контент, не подходящий для несовершеннолетних.',
      NSFW_PROFILE_REQUIRED_ERROR: 'Включение NSFW генерации доступно только при включенной настройке профиля «Показывать NSFW контент».',
      GUIDANCE_SCORE: 'Коэффициент направленности',
      CREATIVE: 'Креативный',
      PRECISE: 'Точный',
      DISABLE: 'Отключить',
      ENABLE: 'Включить',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'Мой аккаунт',
        CHANGE_PERSONA: 'Сменить персонажа',
        DEFAULT_PERSONA: 'Персонаж по умолчанию',
        USERNAME: {
          USERNAME: 'Имя пользователя',
          PLACEHOLDER: 'Введите имя пользователя',
          ERROR: 'Имя пользователя может содержать только латинские буквы (a–z), цифры и дефисы',
          ERROR_LENGTH: 'Имя пользователя должно содержать от 3 до 20 символов.',
        },
        EMAIL: {
          EMAIL: 'Электронная почта',
          PLACEHOLDER: 'Введите вашу электронную почту',
          VERIFIED: 'Почта подтверждена',
          VERIFY: 'Подтвердить почту',
          NOT_VERIFIED: 'Почта не подтверждена',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'Подтверждение почты',
          TEXT_1: 'На адрес отправлено письмо',
          TEXT_2: 'Пожалуйста, нажмите на ссылку в этом письме, чтобы завершить подтверждение.',
          NO_CODE: 'Не получили код?',
          RESEND: 'Отправить снова',
          SEC: 'сек',
          ERROR: 'Не удалось отправить письмо для подтверждения. {{error}}',
          VALIDATION_ERROR: 'Произошла ошибка валидации. Попробуйте еще раз',
          RECEIVE_LINK: 'На указанный Email будет отправлена ссылка для подтверждения.',
        },
        DATE_OF_BIRTH: 'Дата рождения',
        DATE_OF_BIRTH_ERROR: 'Минимальный возраст должен быть не менее 18 лет',
        FILL_OUT_WARNING: 'Необходимо заполнить',
        DESCRIPTION: 'Описание',
        DESCRIPTION_PLACEHOLDER: 'Введите краткое описание здесь',
        SOCIALS: 'Соцсети',
        ADD_NEW: 'Добавить новую',
        SAVE: 'Сохранить',
        SUCCESS: 'Данные успешно сохранены!',
        FAIL: `Не удалось сохранить данные, {{error}}`,
      },
      PREFERENCES: {
        PREFERENCES: 'Настройки',
        THEME: {
          THEME: 'Тема',
          SYSTEM: 'Системная',
          LIGHT: 'Светлая',
          DARK: 'Темная',
        },
        NSFW: {
          TITLE: 'Показывать чат-ботов с изображениями или выражениями непристойного характера (NSFW)',
          ERROR: 'Вы не можете включить отображение контента NSFW. Подтвердите, что вам исполнилось 18 лет на ',
          ERROR_EMAIL: 'Подтвердите почту, чтобы выключить безопасный поиск и открыть больше возможностей.',
          LINK: 'вкладке «Мой аккаунт»',
          SUCCESS: 'Ваш адрес электронной почты успешно подтверждён. NSFW-контент теперь доступен для вас',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Настройки успешно применены!',
          FAIL: 'Не удалось применить настройки',
        },
      },
      SECURITY: {
        SECURITY: 'Безопасность',
        TWO_FACTOR: {
          TITLE: 'Двухфакторная аутентификация',
          DESCRIPTION: 'Двухфакторная аутентификация (2FA) обеспечивает более надежную защиту аккаунта.',
          DOWNLOAD: 'Загрузить Google Authenticator',
          APP_DESCRIPTION:
            'Google Authenticator — это независимый сервис от Google Inc., который защищает вашу учётную запись. После настройки вам потребуется подтвердить вход в приложение или вывод средств, используя пароль, сгенерированный Google Authenticator.',
          SCAN: 'Отсканируйте QR-код или загрузите из магазина приложений.',
          DOWNLOAD_ON_THE: 'Скачать из',
          WORKS_WITH: 'Работает с',
          STEP: {
            STEP: 'Шаг',
            ONE: 'Введите пароль',
            TWO: 'Скачайте приложение',
            THREE: 'Добавьте ключ',
            FOUR: 'Введите код',
            FIVE: 'Скачайте коды',
          },
          CONTINUE: 'Далее',
          CONFIRM: 'Принять',
          ADD_KEY: 'Добавьте ключ в Google Authenticator и сделайте резервную копию.',
          ADD_KEY_TIP: 'Откройте Google Authenticator, отсканируйте QR-код или введите ключ ниже, чтобы добавить токен подтверждения.',
          SCAN_QR_CODE: 'Отсканируйте QR-код или введите ключ ниже в приложение.',
          CODE_TIP:
            'Сохраните свой ключ на случай возникновения проблем со входом в систему, например, потери телефона или других проблем.',
          COPY: 'Копировать',
          COPIED: 'Скопировано',
          ENTER: 'Введите код из приложения Google Authenticator.',
          ENTER_TIP: 'Откройте приложение GA и введите проверочный код в поле ниже.',
          GA_CODE: 'Код GA',
          ENTER_CODE: 'Введите код',
          DOWNLOAD_CODES: {
            TITLE: 'Загрузить резервные коды',
            TIP: 'Сохраните эти резервные коды в надёжном месте. Вы сможете использовать их для доступа к своей учётной записи в случае утери устройства-аутентификатора.',
            WARNING: 'Каждый код можно использовать только один раз. Храните их в безопасности!',
            BUTTON: 'Загрузить резервные коды',
          },
          DISABLE: {
            TITLE: 'Отключить двухфакторную аутентификацию',
            TIP: 'Введите пароль, чтобы отключить двухфакторную аутентификацию. Это сделает ваш аккаунт менее защищенным.',
            WARNING: 'Отключение 2FA удалит важный уровень безопасности вашего аккаунта.',
            BUTTON: 'Отключить',
          },
          ENABLE_SUCCESS: 'Двухфакторная аутентификация успешно включена',
          ENABLE_FAIL: 'Не удалось включить двухфакторную аутентификацию',
          DISABLE_SUCCESS: 'Двухфакторная аутентификация успешно отключена',
          DISABLE_FAIL: 'Не удалось отключить двухфакторную аутентификацию',
          ENTER_CODE_FROM_DEVICE: 'Для вашей безопасности введите 6-значный код, сгенерированный в приложении на вашем устройстве.',
          VERIFICATION_CODE: 'Код подтверждения',
          TRUST_DEVICE: 'Доверять этому устройству 30 дней',
          AUTH_APP: 'Приложение',
          BACKUP_CODE: 'Резервный код',
          DISCLAIMER_1: 'Это помогает защитить вашу учетную запись.',
          DISCLAIMER_2: 'Никогда не делитесь своим OTP с кем-либо.',
          ENTER_BACKUP_CODE: 'Введите резервный код',
          BACKUP_TIP: 'Используйте резервный код, если нет доступа к приложению',
          INVALID_CODE: 'Введённый вами код недействителен. Попробуйте другой',
        },
        PASSWORD: {
          TITLE: 'Пароль',
          AGO: 'Изменён',
          CURRENT: 'Текущий пароль',
          NEW: 'Новый пароль',
          CONFIRM: 'Подтвердите новый пароль',
          SIGN_OUT: 'Выйти из всех активных сессий',
          SET: 'Установить пароль',
          CHANGE: 'Изменить пароль',
          SUCCESS: 'Пароль успешно изменён!',
          FAIL: 'Не удалось изменить пароль, {{error}}',
          PLACEHOLDER: 'Введите пароль',
          TIP: 'У вас не установлен пароль для входа на сайт. Чтобы настроить двухфакторную аутентификацию, необходимо создать пароль для вашего аккаунта.',
          CREATE: 'Создать пароль',
        },
        SOCIAL: {
          TITLE: 'Войти через социальные сети',
          DESCRIPTION:
            'Подключите свою учётную запись {{brand}} к аккаунтам социальных сетей для простого и безопасного входа. Вход через социальные сети позволяет обойти двухэтапную аутентификацию и может снизить безопасность вашей учётной записи.',
          CONNECT: 'Подключить',
          DISCONNECT: 'Отключить',
          CONNECTED: 'Подключено',
          NOT_CONNECTED: 'Не подключено',
          NOTIFICATIONS: {
            SUCCESS: 'Учетная запись {{providerName}} успешно отключена',
            FAIL: 'Не удалось отключить учетную запись, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      TOKENS_TITLE: 'Вы покупаете токены',
      SUBSCRIPTION_TITLE: 'Вы приобретаете подписку',
      RENEWAL: 'Продление произойдет через {{period}} дней за ${{price}}/{{period}} дней. Отменить можно в любое время.',
      SECURE: 'Платежи защищены и зашифрованы',
      CHANGE: 'Изменить',
      SUBTOTAL: 'Промежуточный итог',
      DISCOUNT: 'Скидка',
      TOTAL: 'Итого',
      CONTACT_INFORMATION: 'Контактная информация',
      CHOOSE_SUBSCRIPTION_PERIOD: 'Выберите период подписки',
      CHOOSE_PAYMENT_METHOD: 'Выберите способ оплаты',
      TOS_1: 'Нажимая кнопку «Продолжить», вы подтверждаете, что вам 18 лет или больше и принимаете',
      TOS_2: 'и',
      TOS_3: '. Мы заботимся о вашей конфиденциальности, поэтому платеж по карте будет отображаться как "{{ brand }}".',
      TOS_4: 'По вопросам оплаты, пожалуйста, свяжитесь с поддержкой по адресу {{ email }}.',
      TOS_5: 'Вы соглашаетесь, что мы сохраним ваши платежные данные, чтобы вам не нужно было вводить их снова в будущем.',
      BONUS: 'Бонус',
    },
    DELETE_CHAT: {
      TITLE: 'Удалить чат',
      TEXT: 'Вы уверены, что хотите удалить этот чат? После удаления восстановить его будет невозможно.',
      SUCCESS: 'Чат успешно удален!',
      FAIL: 'Не удалось удалить чат!',
    },
    DELETE_PERSONA: {
      TITLE: 'Удалить персонажа',
      TEXT:
        'Удаление этого персонажа приведет к необратимым последствиям — восстановить его будет невозможно.\n' +
        'История общения с ботами останется, и вы сможете продолжить беседу, но от имени другого персонажа.\n' +
        '\n',
      SURE: 'Вы уверены, что хотите удалить этот профиль?',
      WARNING: 'Текущий персонаж по умолчанию не может быть удален.\n' + 'Сначала выберите другого по умолчанию или создайте нового.',
      SUCCESS: 'Персонаж успешно удален!',
      FAIL: 'Не удалось удалить персонажа!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Удалить чат-бота',
      TEXT_1: 'Удаление чат-бота также приведет к удалению всех чатов и изображений. Их невозможно будет восстановить.',
      TEXT_2: 'Вы уверены, что хотите удалить этого чат-бота?',
      SUCCESS: 'Чат-бот успешно удален!',
      FAIL: 'Не удалось удалить чат-бота!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Заблокировать этого автора?',
      TEXT: 'Вы уверены, что хотите заблокировать всех чат-ботов этого автора? Вы сможете разблокировать их в любое время.',
      BLOCK: 'Заблокировать',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Вы уверены, что хотите разблокировать автора ',
      CANCEL: 'Нет',
      SUCCESS: 'Автор успешно разблокирован!',
      FAIL: 'Не удалось разблокировать автора. Пожалуйста, попробуйте позже.',
    },
    COMPLAIN: {
      TITLE: 'Жалоба',
      DETAILS_PLACEHOLDER: 'Опишите, что вас не устроило',
      MAX_CHECKBOXES: 'Вы можете выбрать максимум 5 чекбоксов',
      CHECKBOX: {
        THREATS: 'Угрозы и домогательства',
        CRUELTY: 'Чрезмерная жестокость',
        FALSE: 'Ложные заявления',
        HATRED: 'Разжигание ненависти',
        NSFW: 'Не для рабочего места (NSFW)',
        HARASSMENT: 'Сексуальные домогательства',
        CHILD_EXPLOIT: 'Эксплуатация детей',
        SELF_HARM: 'Самоповреждения',
        TERRORISM: 'Терроризм и экстремизм',
        ILLEGAL: 'Незаконная деятельность',
        DRUGS: 'Наркоторговля',
        CONFIDENTIALITY: 'Нарушение конфиденциальности',
        IMPERSONATION: 'Самозванство',
        SPAM: 'Коммерческий спам',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Расскажите больше',
      ADDITIONAL_DETAILS: 'Дополнительные детали',
      DETAILS_PLACEHOLDER: 'Опишите, что вас порадовало',
      SUCCESS: 'Ваш отзыв успешно отправлен!',
      FAIL: 'Не удалось отправить отзыв. Пожалуйста, попробуйте позже.',
      FUNNY: 'Смешно',
      HEALTHY: 'Полезно',
      FLIRTY: 'Kокетливо',
      INTERESTING: 'Интересно',
      GOOD_MEMORY: 'Хорошая память',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Модель успешно добавлена в избранное',
        FAIL: 'Не удалось добавить в избранное, попробуйте позже.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Модель успешно удалена из избранного',
        FAIL: 'Не удалось удалить из избранного, попробуйте позже.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Стиль повествования успешно добавлен в избранное',
        FAIL: 'Не удалось добавить в избранное, попробуйте позже.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Стиль повествования успешно удален из избранного',
        FAIL: 'Не удалось удалить из избранного, попробуйте позже.',
      },
    },
    MEMORIES: {
      TITLE: 'Воспоминания',
      PLACEHOLDER_1: 'Здесь пока нет воспоминаний.',
      PLACEHOLDER_2: 'Продолжите чат с ботом или создайте нового.',
      INPUT_PLACEHOLDER: 'Добавить новое воспоминание...',
      SUBTITLE: 'Добавьте воспоминания о ваших прошлых взаимодействиях с персонажем',
      EDIT: 'Редактировать',
      DELETE: 'Удалить',
      PIN: 'Закрепить',
      UNPIN: 'Открепить',
      PINNED: '(Закреплено)',
      EDITED: '(изменено)',
      DELETE_TEXT: 'Вы уверены, что хотите удалить это воспоминание? После удаления восстановить его будет невозможно.',
      MEMORIES_ENABLED: 'Воспоминания успешно включены!',
      MEMORIES_DISABLED: 'Воспоминания успешно отключены!',
      FAILED_TO_UPDATE: 'Не удалось обновить настройки воспоминаний!',
    },
    REGISTRATION: {
      TITLE: 'Создайте аккаунт',
      LOGIN_WITH_EMAIL: 'Войти с помощью email',
      CONTINUE: 'Продолжить',
      HAVE_AN_ACCOUNT: 'Уже есть аккаунт?',
      DONT_HAVE_AN_ACCOUNT: 'Нет аккаунта?',
      YOU_AGREE: 'Регистрируясь, вы соглашаетесь с нашими',
      TERMS_AND_CONDITIONS: 'Условиями и положениями',
      YOU_HAVE_READ: 'и вы прочитали нашу',
      PRIVACY_POLICY: 'Политику конфиденциальности',
      FORGOT_PASSWORD: 'Забыли пароль?',
      CONTINUE_WITH: 'или продолжить через',
      SEND_MAGIC_LINK: 'Отправить Magic Link на почту',
    },
    MAGIC_LINK: {
      TITLE: 'Войти с помощью Magic Link',
      TEXT: 'Введите свою электронную почту, и мы отправим вам Magic Link для мгновенного входа',
      SEND: 'Отправить Magic Link',
      SUCCESS: 'Проверьте свою почту — мы отправили вам Magic Link для мгновенного входа!',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Восстановить пароль',
      RECOVERY_LINK:
        'Ссылка для восстановления отправлена на вашу почту. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке, чтобы сбросить пароль.',
      ENTER_EMAIL: 'Введите адрес электронной почты, который вы использовали при регистрации, и мы отправим вам инструкции',
      RESET_PASSWORD: 'Сбросить пароль',
    },
    NONEXISTING: {
      TITLE: 'Ой...',
      TEXT: 'То, что вы ищете, может находиться в другом месте или просто не существует. Пожалуйста, попробуйте еще раз.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Выбрать персонажа',
      SUBTITLE: 'Изменение персонажа во время беседы может нарушить повествование.',
      SUCCESS: 'Персонаж успешно изменен!',
      FAIL: 'Не удалось изменить персонажа!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Импорт чат-бота',
      DESCRIPTION: 'В настоящее время мы поддерживаем импорт персонажей из spicychat.ai и juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Импорт через JSON или изображение',
        DESCRIPTION: 'Загрузите JSON-файл персонажа или изображение со встроенными данными персонажа.',
        SUPPORTED_LABEL: 'Поддерживаемые форматы:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Нажмите, чтобы выбрать, или перетащите файл сюда',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Импорт по URL',
        ENTER: 'Введите URL-адрес поддерживаемого веб-сайта.',
        CHATBOT_URL: 'URL-адрес чат-бота',
        IMPORT_FROM_URL: 'Импорт из URL',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: 'Привяжите свой аккаунт Boosty',
      ENTER_EMAIL_DESCRIPTION: 'Для оплаты подписки Boosty, пожалуйста, введите Email, привязанный к вашему аккаунту Boosty ниже',
      EMAIL_WARNING: 'Внимание! Email привязывается к вашему аккаунту CAICHAT.AI и не может быть изменен',
      EMAIL_LABEL: 'Email, привязанный к Boosty',
      EMAIL_PLACEHOLDER: 'Введите ваш Email',
      WHERE_FIND_EMAIL: 'Где найти информацию о моем email на Boosty?',
      INSTRUCTION_STEP_1: 'Нажмите на свой аватар и выберите "Настройки аккаунта" из выпадающего меню',
      INSTRUCTION_STEP_2: 'На вкладке "Профиль" вы найдете свой Email. Просто скопируйте его и вставьте в форму на этой странице',
      HAVE_YOU_PAID: 'Вы оплатили подписку?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'Если вы оплатили подписку Boosty, пожалуйста, подтвердите это ниже. Мы синхронизируем данные для проверки.',
      SYNC_FAILED: 'Синхронизация не удалась. Пожалуйста, проверьте правильность вашего email и успешность оплаты подписки Boosty.',
      CONTACT_SUPPORT: 'Если у вас есть вопросы или необходимо изменить указанный Email, пожалуйста, свяжитесь с поддержкой.',
      RETURN_TO_BOOSTY: 'Вернуться к оплате на Boosty',
      GO_TO_BOOSTY: 'Оплатить на Boosty',
      I_HAVE_PAID: 'Я оплатил подписку',
      SUCCESS_PAYMENT: 'Вы успешно оплатили подписку Boosty!',
      CONGRATULATIONS: 'Поздравляем! Теперь вы можете использовать больше функций на CAICHAT.AI. Начните новые чаты прямо сейчас!',
      DATA_SYNCHRONIZED: 'Данные синхронизированы',
      SUBSCRIPTION_VALID_UNTIL: 'Подписка действительна до',
      MY_PREVIOUS_CHATS: 'Мои предыдущие чаты',
      GO_TO_HOMEPAGE: 'Перейти на главную',
      SYNCHRONIZING_DATA: 'Синхронизация данных',
    },
    TOP_UP: {
      TITLE: 'Пополните баланс токенов',
      NOT_ENOUGH: 'У вас недостаточно',
      TOKENS: 'токенов для генерации изображений.',
      TOP_UP_AND: 'Пополните баланс и',
      GENERATE_AMAZING_PHOTOS: 'создавайте потрясающие фотографии',
      RIGHT_IN_THE_CONVERSATION: 'прямо в чате!',
      BUY_TOKENS: 'Купить токены',
    },
    PAYMENT_RESULT: {
      PAYMENT_ORDER_DETAILS: 'Детали платёжного заказа',
      ORDER_ID: 'ID заказа',
      STATUS: 'Статус',
      AMOUNT: 'Сумма',
      PURCHASED: 'Приобретено',
      PAYMENT_METHOD: 'Метод оплаты',
      PROVIDER_ORDER_ID: 'ID заказа провайдера',
      CREATED_AT: 'Создано',
      COMPLETED_AT: 'Завершено',
      STATUSES: {
        COMPLETED: 'Завершено',
        FAILED: 'Неудача',
        PENDING: 'В ожидании',
        PROCESSING: 'Обработка',
        CANCELLED: 'Отменено',
        REFUNDED: 'Возвращено',
      },
    },
    CREATE_REFERRAL_CAMPAIGN: {
      CREATE: 'Создать кампанию',
      EDIT: 'Редактировать кампанию',
      NAME: 'Название кампании',
      NAME_PLACEHOLDER: 'Введите текст',
      NAME_DESCRIPTION:
        'Название кампании будет отображаться только для вас и используется исключительно для удобства поиска. Другие пользователи его не увидят.',
      CODE_DESCRIPTION: 'Реферальный код будет сгенерирован автоматически при создании кампании.',
    },
    DELETE_REFERRAL_CAMPAIGN: {
      DELETE: 'Удалить эту кампанию?',
      TEXT: 'После удаления другие пользователи не смогут использовать промокод этой кампании. Восстановление данных будет невозможно. Вы уверены, что хотите удалить?',
    },
  },
  BLOCKS: {
    BANNER_MAIN: {
      SLIDE_1: {
        TITLE: 'РАСШИРЬ ГРАНИЦЫ ИСТОРИИ',
        TEXT: 'Персонажи, которые помнят всё — тебе не придётся повторяться.',
        BUTTON: 'Прокачай память',
      },
      SLIDE_2: {
        TITLE: 'Твоя история оживает',
        TEXT: 'Премиум-модели, генерация изображений без ограничений, голос для твоего компаньона!',
        BUTTON: 'Получи всё',
      },
      SLIDE_3: {
        TITLE: 'Новый уровень общения',
        TEXT: 'Глубокие ответы и насыщенные сцены. Персонажи, проживающие историю вместе с тобой.',
        BUTTON: 'Разблокируй всю мощь',
      },
      SLIDE_NOT_AUTH: {
        TITLE: 'Общение с ИИ без ГРАНИЦ',
        TEXT: 'Тысячи уникальных персонажей! Регистрируйся и погружайся в бесконечные истории!',
        BUTTON: 'Начни бесплатно',
      },
      SOCIALS_SLIDE: {
        TITLE: 'Присоединяйтесь к сообществу',
        TITLE_MOBILE: 'Присоединяйтесь!',
        TEXT: 'Узнавайте первыми о новостях и крутых функциях в наших социальных сетях.',
        JOIN_OUR: 'Присоединяйтесь к Discord',
        FOLLOW_US_ON: '{{target}}',
        DISCORD: 'Discord',
        TIKTOK: 'TikTok',
        INSTAGRAM: 'Instagram',
      },
      SLIDE_GIVEAWAY: {
        TITLE: 'Еженедельные розыгрыши 30k токенов',
        DESCRIPTION: 'Присоединяйтесь к нашему Discord-каналу и участвуйте в розыгрыше токенов',
      },
      MORE_TOKENS: {
        TITLE: 'Больше токенов для вас',
        DESCRIPTION: 'Присоединяйтесь к Discord и получайте бесплатные токены каждую неделю',
      },
    },
    SORT: {
      MOST_CHATS: 'Больше всего чатов',
      NEWEST: 'Новые',
      OLDEST: 'Старые',
      MOST_POPULAR: 'Самые популярные',
      MOST_LIKED: 'Понравившиеся',
      ALL_MODELS: 'Все',
      FREE: 'Бесплатно',
      RECOMMENDED: 'Рекомендуемые',
      TOKENS: 'Токены',
      TRENDING: 'В тренде',
      MY_PLAN: 'Мой план',
      A_Z: 'A–Я',
      Z_A: 'Я–A',
      PRICE_ASC: 'Сначала дешёвые',
      PRICE_DESC: 'Сначала дорогие',
    },
    SORT_MODAL: {
      TITLE: 'Выберите сортировку',
    },
    LEFT_SIDEBAR: {
      HOME: 'Главная',
      SMART_SEARCH: 'Умный поиск',
      CATALOG: 'Каталог',
      CHATS: 'Чаты',
      MY_PERSONAS: 'Мои Персоны',
      CREATE_CHATBOT: 'Создать Чатбота',
      MY_CHATBOTS: 'Мои Чатботы',
      MY_GAMES: 'Мои Игры',
      FAVORITES: 'Избранное',
      BLOCKED_CREATORS: 'Заблокированные',
      SUBSCRIBE: 'Подписка',
      NOTIFICATIONS: 'Уведомления',
      HELP: 'Помощь',
      UPGRADE: 'Обновить',
    },
    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Обновить план',
      GET_PLAN: 'Улучшить подписку',
      FREE: 'Бесплатный',
      ACTIVE: 'Активный',
      DREAMER: 'Мечтатель',
      EXPLORER: 'Исследователь',
      STORY_GOD: 'Бог историй',
      NEW_CHAT: 'Новый чат',
      EXTENSIONS: 'Расширения',
      CREATE_PRESET: 'Создать пресет',
      PERSONAS: 'Персоны',
      VOICES: 'Озвучка',
      BACKGROUNDS: 'Фоны',
      RECENT: 'Недавно использованные ИИ модели',
      PROMPT: 'Поведение',
      NO_MODEL_SELECTED: 'Не выбрана модель для продолжения чата',
      SELECT_MODEL_PROMPT: 'Выберите модель и поведение',
      SELECT_MODEL: 'Выбрать AI-модель',
      BOT_REMOVED: 'Этот чат-бот был удалён автором или администрацией. Начните общаться с другими ботами прямо сейчас.',
      CREATE_NEW_CHATBOT: 'Создать чат-бота',
      OPEN_HOMEPAGE: 'На главную',
    },
    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Сбросить фильтр',
      SEARCH_TAGS: 'Поиск тегов',
      SHOW: 'Показать',
      CHATBOTS: 'чат-ботов',
      NO_TAGS: 'У чат-ботов этого автора пока нет тегов',
    },
    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Безопасный поиск',
    },
    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Введите приветствие',
      ADD_NEW_GREETING: 'Добавить новое Приветствие',
      GREETINGS: 'Первое сообщение',
      PERSONALITY: 'Личность',
      SCENARIO: 'Сценарий',
      DIALOG: 'Диалог',
      NOTES: 'Заметка автора',
      DESCRIPTION: 'Описание',
      AVATAR: 'Аватар',
      NAME: 'Имя',
      MARKDOWN_FONT_SIZE: {
        NORMAL: 'Обычный текст',
        H1: 'Заголовок 1',
        H2: 'Заголовок 2',
        H3: 'Заголовок 3',
        QUOTE: 'Цитата',
      },
      GREETINGS_PLACEHOLDER:
        'Например: Известный археолог с таинственным прошлым, Элара Найтшейд провела десятилетия, исследуя забытые храмы и древние руины по всему миру. Со своими характерными серебристыми прядями и пронизывающими янтарными глазами, она заслужила уважение в академических кругах, сохраняя при этом ауру загадочности.',
      PERSONALITY_PLACEHOLDER:
        'Опишите личность персонажа, черты характера, прошлое, стиль речи и т.д. Используйте ясный и краткий язык. Примеры: «остроумный и саркастичный», «всегда говорит рифмами», «боится пауков», «бывший детектив, преследуемый прошлым делом».',
      SCENARIO_PLACEHOLDER: 'Опишите сценарий для персонажа. Используйте ясный и краткий язык.',
      DIALOG_PLACEHOLDER:
        "Приведите пример диалога, показывающего, как говорит персонаж. Используйте формат: 'Пользователь: Привет\nПерсонаж: [ответ персонажа]'. Добавьте несколько реплик, чтобы продемонстрировать стиль общения.",
      NOTES_PLACEHOLDER: 'Напишите краткое пояснение для пользователей, как лучше взаимодействовать с этим ботом',
      CHAT_BACKGROUND: 'Фон чата',
      DELETE_CHAT_BACKGROUND: 'Удалить фон чата',
      HIDE_THIS_BLOCK: 'Скрыть этот блок',
    },
    TOKENIZATOR: {
      TOKENS: 'токены',
    },
    BLOCK_BUTTON: {
      NO_BLOCKED: 'У вас нет заблокированных авторов',
      SHARE: 'Поделиться',
      DELETE_CHATBOT: 'Удалить чат-бота',
      EDIT: 'Редактировать',
      BLOCK_CREATOR: 'Заблокировать автора',
      UNBLOCK_CREATOR: 'Разблокировать',
      REPORT: 'Жалоба на автора',
      REPORT_CHATBOT: 'Жалоба на чат-бота',
      VOICE_OVER: 'Озвучка',
      DELETE_IMAGE: 'Удалить изображение',
      REGENERATE_MESSAGE: 'Сгенерировать сообщение заново',
      NEW_CHAT_FROM_HERE: 'Новый чат отсюда',
      BLOCK_SUCCESS: 'Пользователь успешно заблокирован',
      BLOCK_ERROR: 'Не удалось заблокировать пользователя. Попробуйте позже.',
      UNBLOCK_SUCCESS: 'Пользователь успешно разблокирован',
      UNBLOCK_ERROR: 'Не удалось разблокировать пользователя. Попробуйте позже.',
      IMAGE_SETTINGS: 'Настройки изображения',
      RATE_MESSAGE: 'Оценить сообщение',
    },
    CHAT_INPUT: {
      ACTION: 'Действие',
      TYPE_YOUR_MESSAGE: 'Введите сообщение...',
      WRITE_IN_LANGUAGE: 'Напиши на русском',
      DESCRIBE_YOUR_FEELINGS: 'Опиши чувства',
      GET_OUT_OF_THE_LOOP: 'Выйди из повторов',
      EDIT_MESSAGE_PLACEHOLDER: 'Редактировать сообщение...',
      DELETED_PERSONA_PLACEHOLDER: 'Ваша персона удалена. Выберите другую.',
      DELETED_PRESET_PLACEHOLDER: 'Модель недоступна. Пожалуйста, выберите другую.',
      SUBSCRIBE_PLACEHOLDER: 'Выбранная AI-модель не доступна с текущей подпиской.',
      SELECT_PERSONA: 'Выбрать персону',
      CHANGE_MODEL: 'Сменить модель',
      DELETED_CHAT_TITLE: 'Этот чат-бот был удалён.',
      DELETED_CHAT_TEXT: 'Начните общаться с другими ботами прямо сейчас.',
      GO_HOME: 'На главную страницу',
      NO_MORE_TOKENS: `<span>У вас нет</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="size-4 inline-block"><path d="M12.4137 5.51725H8.63443L12.1379 0H7.72409L3.58618 8.27588H6.84137L3.58618 16L12.4137 5.51725Z" fill="#ff9f32"/></svg><span>токенов для этой модели. Пополните баланс или перейдите на другую модель</span>`,
      LOW_QUALITY_MODEL: 'Модель низкого качества',
      AVATAR_CHANGED: 'Аватар был изменён',
    },
    PRICING_CARD_GROUP: {
      WEEKLY: 'Неделя',
      MONTHLY: '1 месяц',
      // Используется в purchase history таблице
      ONE_MONTH: '1 месяц',
      THREE_MONTHS: '3 месяца',
      YEARLY: 'Год',
      ONE_YEAR: 'Год',
      SUBSCRIBE_PLAN: 'Оформить подписку',
      UP_TO: 'До {{percent}}%',
      OFF: 'Скидка {{percent}}%',
      PRICE: 'Выгода {{percent}}%',
    },
    PRICING_CARD: {
      MOST_POPULAR: 'Самый популярный',
      MY_SUBSCRIPTION: 'Моя подписка',
      SUBSCRIBE: 'Подписаться',
      UNSUBSCRIBE: 'Отписаться',
      ACTIVE: 'Активен уровень выше',
      IN_ADDITION: 'В дополнение к предыдущим уровням:',
      SEE_ALL_FEATURES: 'Посмотреть все возможности...',
      IN_EXTRA: 'дополнительно по промокоду',
    },
    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Дата рождения:',
      REGISTERED: 'Зарегистрирован:',
      SUBSCRIBERS: 'Подписчики',
      LIKES: 'Лайки',
      MY_CHATBOTS: 'Мои чатботы',
      MY_PUBLIC_PAGE: 'Моя публичная страница',
      BALANCE: 'Баланс:',
      ADD_TOKENS: 'Добавить токены',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        '{{brand}} работает на базе ИИ для творческого сторителлинга и ролевых игр. Все беседы вымышленные, не воспринимайте их как реальные факты. Используйте ответственно!',
      SHOW_PREVIOUS: 'Показать предыдущее',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Ваша история начинается здесь!',
      SUBTITLE: 'Остался всего один шаг, чтобы открыть потрясающие возможности и новые миры',
      ENTER_CODE: 'Введите код приглашения',
      INVITE_CODE: 'Код приглашения',
      LETS_GO: 'Поехали!',
      NEED_CODE: 'Нужен код приглашения?',
      JOIN_DISCORD: 'Получить доступ в Discord',
      SIGN_OUT: 'Выйти',
    },
    TOKEN_PACK_CARD: {
      BUY: 'Купить',
      SALE: 'Скидка',
      BONUS: 'Бонус',
    },
    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Популярно',
      FUNCTION_LIMIT: 'Функция/Лимит',
      INCLUDED_IN_PLAN: 'Включено в план',
      NOT_INCLUDED_IN_PLAN: 'Не включено в план',
      MAIN_FUNCTION: 'ОСНОВНАЯ ФУНКЦИЯ',
      BONUS_FOR_SUB: 'Бонусные токены за подписку (при продлении)',
      UNLIMITED_MESSAGES: 'Безлимитные сообщения',
      COUPON_MONTH: 'Одноразовый купон при подписке на 30 дней',
      COUPON_YEAR: 'Одноразовый купон при годовой подписке',
      USER_IDENTITIES: 'Персоны пользователя',
      USER_IDENTITIES_TOOLTIP:
        'После окончания подписки вы перейдёте на Free plan и не сможете создавать новых персон, пока не освободите место.',
      ABILITY_TO_USE: 'Возможность использовать собственные модели',
      ACCESS_OTHER_EXTENSIONS: 'Доступ к другим и стандартным расширениям',
      AVAILABLE_CONTEXT_TOKENS: 'Доступные токены контекста',
      AVAILABLE_LLM_TOKENS: 'Доступные токены ответа LLM',
      LIMITATION_ON_MODELS: 'ОГРАНИЧЕНИЯ ПО МОДЕЛЯМ',
      AVAILABLE_CHARACTERS: 'Доступные персонажи',
      NO_RESTRICTIONS:
        'Нет ограничений на использование Контекста, Ответов LLM, Персонажей и системных подсказок при использовании собственных моделей, кроме указанных в разделе «Ваши AI модели»',
      CREATE_EXTENSIONS: 'Создавать собственные расширения',
      ADDITIONAL_FEATURES: 'ДОПОЛНИТЕЛЬНЫЕ ФУНКЦИИ',
      SYSTEM_PROMPTS: 'Системные подсказки',
      IMAGE_GEN: 'Генерация изображений доступна за токены – определённое количество изображений в день бесплатно',
      AVATAR_GEN_ALL: 'Генерация аватаров для всех персонажей, включая приватных',
      CHAT_ENCRYPTION: 'Шифрование чата',
      ACCESS_EXTENSIONS: 'Доступ к расширениям',
      ACCESS_MEMORY_MANAGER: 'Доступ к менеджеру памяти (Memories) с возможностью добавлять свои записи',
      SEMANTIC_MEMORY: 'Семантическая память 2.0',
      TTS: 'Текст-в-Речь (озвучка ответов)',
      CREATE_PRIVATE_CHARACTERS: 'Создавать приватных персонажей',
      CREATE_PUBLIC_CHARACTERS: 'Создавать публичных персонажей',
      AD_FREE: 'Без рекламы',
      NO_QUEUE: 'Без очереди',
      ADDITIONAL_TOOLS: 'Дополнительные инструменты для создания персонажей и расширений',
      LIMITED_EDITION_MODEL: 'Модель ограниченного выпуска',
      UP_TO_200: 'до 200',
      UNLIMITED: 'Безлимитно',
      ONLY_YOUR_OWN_AND_FREE: 'Только свои и бесплатные',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Наши рекомендации без ограничений по токенам',
      UP_TO_1_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'До 1 в день + безлимит за плату',
      ONLY_SPEECH: 'Только речь',
      UNLIMITED_LOW_QUALITY: 'Безлимит, низкое качество',
      UNLIMITED_MEDIUM_QUALITY: 'Безлимит, среднее качество',
      UNLIMITED_HIGH_QUALITY: 'Безлимит, высокое качество',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% скидка на неделю',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Ежемесячный купон: 10% скидка на токены на неделю',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% скидка на неделю',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Ежемесячный купон: 20% скидка на токены на неделю',
      THE_ENTIRE_ANSWER: 'Полный ответ',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% скидка на неделю',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Ежемесячный купон: 30% скидка на токены на неделю',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Персонажи, на которых потрачено более 2000 токенов на личность и более 3000 токенов на приветствия (учитывается большее значение), не могут использовать бесплатные модели.',
      UP_TO_5k_TOKENS: 'До 5000 токенов, потраченных на личность',
      UP_TO_5k_TOKENS_ACTIVE: 'До 5000 токенов на личность + модели уровня Active',
      UP_TO_5k_TOKENS_DREAMER: 'До 5000 токенов на личность + модели уровня Dreamer',
      UP_TO_5k_TOKENS_CREATOR: 'До 5000 токенов на личность + модели уровня Creator',
      UP_TO_5k_TOKENS_STORY_GOD: 'До 5000 токенов на личность + модели уровня Story GOD',

      ACTIVE: 'Активный',
      FREE_PLAN: 'Бесплатный',
      FREE_MODELS: 'Бесплатные модели',
      FREE_MODELS_FREE: 'Бесплатные модели для персонажей с личностью до 5000 токенов',
      FREE_MODELS_ACTIVE: 'Модели бесплатного плана + модели уровня Активный',
      FREE_MODELS_DREAMER: 'Модели бесплатного плана + модели уровня Мечтатель',
      FREE_MODELS_CREATOR: 'Модели бесплатного плана + модели уровня Создатель',
      FREE_MODELS_STORY_GOD: 'Модели бесплатного плана + модели уровня Бог историй',
    },
    MODEL_PROMPT_PRESET: {
      MODEL: 'Модель',
      DEFAULT: 'По умолчанию',
      RECOMMENDED: 'Рекомендовано',
      PRESET: 'Пресет',
      LAST_USED: 'Недавно',
      SUCCESS: 'Настройки успешно применены!',
      ERROR: 'Не удалось применить настройки!',
      INCOMPATIBLE: 'Несовместимо с моделью ИИ',
      WE_RECOMMEND: 'Мы рекомендуем',
      AUTHORS_CHOICE: 'Выбор автора',
      POPULAR: 'Популярное',
      UNSUITABLE_SUBSCRIPTION: 'Ваш тарифный план не подходит для этой модели.',
    },
    PUBLIC_PROFILE_HEADER: {
      COPIED: 'скопировано',
      SUBSCRIBERS: 'Подписчики',
      LIKES: 'Лайки',
      CHATBOTS: 'Чат-боты',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'Вы заблокировали этого автора. ',
      UNBLOCK: 'Разблокировать',
    },
    PROMPTS_BLOCK: {
      REPLACE: 'Заменить ИИ-модель',
      SELECT: 'Выбрать ИИ-модель',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Загрузить',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'Вы также можете оформить подписку через Boosty, который предлагает гибкие варианты для ваших потребностей.',
      HAVE_SUBSCRIBE: 'У вас уже есть подписка через Boosty. Ваша подписка действительна до:',
      GO_TO_BOOSTY: 'Перейти в Boosty',
      SUBSCRIBE_TO_BOOSTY: 'Подписаться на Boosty',
      BACKEND_SUCCESSFULLY_NOTIFICATION: 'Boosty успешно привязан к вашему аккаунту',
    },
    TAGS_SELECT: {
      TAGS: 'Теги',
      PLACEHOLDER: 'Отметьте вашего персонажа подходящими ключевыми словами (максимум 10 тегов)',
      CREATE_NEW: 'Создать новый – {{tag}}',
      LIMIT: 'Не более 10 тегов',
      CUSTOM_TAG_VALIDATION:
        'Пользовательские теги должны содержать от 3 до 20 символов и включать только латинские буквы (A–Z) и цифры (0–9)',
      ALREADY_SELECTED: 'Тег уже выбран',
    },
    CHATBOT_PERSONA_SELECTOR: {
      ADD_NEW: 'Добавить',
    },
    CHATBOT_PREVIOUS_CHATS: {
      PREVIOUS_CHATS: 'Ваши предыдущие чаты:',
    },
    CHATBOT_INFORMATION_GREETINGS: {
      CHOOSE_FIRST_MESSAGE: 'Выберите первое сообщение:',
    },
    CHATBOT_INFORMATION_SCENARIO: {
      RECOMMENDED_LANG: 'Для корректной работы чатбота рекомендуется заполнять на английском языке',
    },
    REFERRAL: {
      MY_REFERRALS: 'Мои рефералы',
      ACTIVE: 'Активные',
      LOST: 'Потерянные',
      NON_ACTIVE: 'Неактивные',
      TOTAL: 'Всего',
      CREATE_NEW_CAMPAIGN: 'Создать новую кампанию',
      NO_CAMPAIGNS: 'У вас пока нет созданных кампаний',
      CREATE_FIRST_CAMPAIGN: 'Создайте свою первую кампанию и начните зарабатывать',
      CAMPAIGN_NAME: 'Название кампании',
      REFERRAL_CODE: 'Реферальный код',
      INVITE_CODE: 'Код',
      YOUR_REFERRAL_CODE: 'Ваш реферальный код',
      ACTIVATIONS: 'Активации',
      REFERRALS: 'Рефералы',
      INCOME: 'Доход',
      COPY_LINK: 'Скопировать ссылку',
      COPY_CODE_NOTIFICATION: 'Реферальный код успешно скопирован',
      COPY_URL_NOTIFICATION: 'URL кампании успешно скопирован',
      START_DATE: 'Дата с',
      END_DATE: 'Дата по',
      CHART: {
        INCOME: 'Доход',
        ACTIONS: 'Действия',
        REGISTRATIONS: 'Регистрации',
        LINK_TRANSITIONS: 'Переходы',
        CODE_ACTIVATIONS: 'Активации',
      },
      TABS: {
        PLACEHOLDER: {
          TITLE: 'У вас пока нет истории рефералов',
          TIP: 'Поделитесь своей реферальной ссылкой прямо сейчас',
          BUTTON: 'Скопировать ссылку',
        },
        STATISTICS: {
          TITLE: 'Статистика',
          DATE: 'Дата',
          CLICKS: 'Переходы',
          NEW_REFERRALS: 'Новые',
          LOST: 'Потерянные',
          INCOME: 'Доход',
          SAVE: 'Сохранить CSV',
        },
        TOP_REFERRALS: {
          TITLE: 'Топ рефералы',
          USER: 'Пользователь',
          REGISTRATION_DATE: 'Дата регистрации',
          STATUS: 'Статус',
          STATUSES: {
            ACTIVE: 'Активный',
            INACTIVE: 'Неактивный',
            LOST: 'Потерян',
          },
          INCOME: 'Доход',
        },
        HISTORY: {
          TITLE: 'История',
          DATE: 'Дата',
          USER: 'Пользователь',
          INCOME: 'Доход',
          INFO: 'Информация',
          COMMISSION: {
            PURCHASE: 'Комиссия с покупки',
            SUBSCRIPTION: 'Комиссия с подписки',
            USAGE: 'Комиссия за использование',
            UNKNOWN: 'Комиссия',
          },
        },
      },
      NOTIFICATIONS: {
        SUCCESS: 'Реферальный код успешно применён',
        OWN_CODE_ERROR: 'Вы не можете применить собственный реферальный код',
        CAMPAIGN_NOT_ACTIVE: 'Эта кампания не активна',
        CAMPAIGN_LIMIT: 'Невозможно создать больше 10 активных кампаний',
        COOLDOWN_NOT_EXPIRED: 'Реферальный код уже применён',
        SIGN_IN_TO_APPLY_CODE: 'Реферальный код сохранён. Пожалуйста, авторизуйтесь, чтобы применить его.',
        CODE_MUST_BE: 'Реферальный код должен состоять ровно из 8 заглавных букв и цифр',
        CODE_INVALID: 'Реферальный код не найден или неактивен',
      },
    },
    PURCHASE_HISTORY: {
      DOWNLOAD: 'Скачать CSV',
      CSV: 'CSV',
      NO_HISTORY: 'У вас пока нет истории покупок',
      TIP: 'Оформите подписку или купите токены',
      BUTTON: 'Выберите тарифный план',
      INFO: 'Инфо',
      NAME: 'Имя',
      STATUS: 'Статус',
      CREATED_AT: 'Создано',
      AMOUNT: 'Сумма',
      METHOD: 'Метод',
      MORE: 'Подробнее',
      DISPLAY_ROWS: 'Отображать строки',
      NO_RESULTS: 'По вашему запросу ничего не найдено',
      NO_RESULTS_TIP: 'Попробуйте изменить параметры поиска',
      START_DATE: 'От',
      END_DATE: 'До',
      FILTER: 'Фильтр',
      STATUSES: {
        ALL: 'Все статусы',
        PENDING: 'В ожидании',
        PROCESSING: 'В обработке',
        COMPLETED: 'Завершено',
        FAILED: 'Не удалось',
        REFUNDED: 'Возвращено',
        CANCELLED: 'Отменено',
      },
    },
    BALANCE_HISTORY: {
      WEEK: 'За неделю',
      MONTH: 'За месяц',
      SOURCE: 'Источник',
      COST_RATIO: 'Соотношение затрат',
      EXPENSES: 'Расходы',
      NO_RESULT: 'История вашего баланса в настоящее время пуста',
      TIP: 'Данные появятся здесь, когда вы начнёте общаться с ботами или генерировать изображения.',
      BUTTON: 'Выбрать чат-бота',
      NO_RESULT_FOR_QUERY: 'По вашему запросу ничего не найдено',
      TIP_FOR_QUERY: 'Попробуйте изменить параметры поиска',
      SPEND_TYPE: {
        CHAT: 'Чат',
        IMAGE: 'Изображения',
        CUSTOM_AGENT: 'Пользовательский агент',
        IMG_PROMPT_TUNER: 'Тюнер промптов',
        AGENT: 'Агент',
        LORE_BOOK: 'Лор-книга',
        MEMORIES: 'Память',
        SUGGESTION: 'Совет',
        IMAGE_PROMPT: 'Промпт изображений',
        IMAGE_DESCRIPTION: 'Описание изображений',
        AVATAR_NSFW_MODERATION: 'NSFW аватар',
        CHARACTER_MODERATION: 'Модерация персонажа',
        PROMPT_MODERATION: 'Модерация промпта',
        IMAGE_AGE_MODERATION: 'Возрастная модерация',
      },
      IN: 'вх',
      OUT: 'исх',
      IMAGES: 'Изображения',
      CHATBOT_REMOVED: 'Чатбот удалён',
    },
    MONETIZATION: {
      TABS: {
        CHATBOTS: 'Чат-боты',
        BILLING: 'Биллинг',
      },
      CHATBOTS: {
        PLACEHOLDER: 'Поиск по имени',
        INCOME: 'Доход',
        WITHDRAWALS: 'Выводы средств',
        CHATS: 'Чаты',
        USERS: 'Пользователи',
        RANGE: {
          DAY: '1Д',
          THREE_DAYS: '3Д',
          WEEK: '1Н',
          MONTH: '1М',
          THREE_MONTHS: '3М',
          SIX_MONTHS: '6М',
          YEAR: '1Г',
          ALL: 'Все',
        },
        EMPTY_PLACEHOLDER: {
          EARN: 'Зарабатывайте с AI-ботами',
          CREATE: 'Создайте своего первого бота и получайте процент от его дохода',
          NO_EARNING_BOT: 'Ни один из ваших ботов ещё не принес дохода',
          COME_BACK_LATER: 'Пожалуйста, попробуйте вернуться сюда позже',
        },
        DISCLAIMER: 'Показаны только боты, которые приносят доход',
      },
      BILLING: {
        MY_BALANCE: 'Мой баланс',
        TOTAL_INCOME: 'Общий доход',
        REVENUE_AVAILABLE: 'Доступно к выводу',
        ONCE: 'Вы можете выводить средства только один раз в 24 часа',
        WITHDRAW_VIA: 'Вывести через',
        LAST_WITHDRAWAL: 'Последний вывод',
        LEFT: 'осталось',
        BLOCKED: 'Вывод заблокирован',
        UNLOCK_TIP: 'Чтобы разблокировать вывод средств, пожалуйста, пройдите процесс KYC-верификации.',
        KYC_VERIFICATION: 'KYC-верификация',
        SECTION_UNDER_DEVELOPMENT: 'Временно недоступно. Раздел в разработке.',
        PLACEHOLDER: {
          TITLE: 'Нет записей о выводах средств',
          DESCRIPTION: 'Ваша история выводов средств в настоящее время пуста',
        },
        TABLE: {
          NAME: 'Имя',
          STATUS: 'Статус',
          DATE: 'Дата',
          TIME: 'Время',
          INCOME: 'Доход',
          INFO: 'Инфо',
          INVOICE: 'Счёт',
        },
      },
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Только что',
      MINUTES_AGO: '{{count}} {{minutes}} назад',
      HOURS_AGO: '{{count}} {{hours}} назад',
      DAYS_AGO: '{{count}} {{days}} назад',
      WEEKS_AGO: '{{count}} {{weeks}} назад',
      MONTHS_AGO: '{{count}} {{months}} назад',
      ONE_MINUTES: 'минуту',
      FEW_MINUTES: 'минуты',
      MANY_MINUTES: 'минут',
      ONE_HOURS: 'час',
      FEW_HOURS: 'часа',
      MANY_HOURS: 'часов',
      ONE_DAYS: 'день',
      FEW_DAYS: 'дня',
      MANY_DAYS: 'дней',
      ONE_WEEK: 'неделю',
      FEW_WEEKS: 'недели',
      MANY_WEEKS: 'недель',
      ONE_MONTH: 'месяц',
      FEW_MONTHS: 'месяца',
      MANY_MONTHS: 'месяцев',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'сообщение',
      FEW_MESSAGES: 'сообщения',
      MANY_MESSAGES: 'сообщений',
    },
    TIME: {
      H: 'ч',
      M: 'м',
      S: 'с',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Чат-бот "{{name}}" успешно создан!',
      UPDATE_SUCCESS: 'Чат-бот успешно обновлен!',
      UPDATE_ERROR: 'Ошибка обновления чат-бота!',
      REQUIRED_FIELDS: 'Обязательные поля должны быть заполнены:',
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'Новый разговор начат с выбранного сообщения!',
      ERROR: 'Произошла ошибка при обработке запроса',
      REPORT_MESSAGE_SENT: 'Ваша жалоба отправлена',
      ENCRYPTION_SAVE: 'Ваши настройки шифрования успешно сохранены.',
      ENCRYPTION_DELETE: 'Шифрование отменено.',
      ENCRYPTION_LIMIT:
        'Вы достигли лимита зашифрованных чатов! Расшифруйте несколько чатов или обновите свой тариф, чтобы продолжить шифровать новые.',
      COMPLAIN_WARNING:
        'В зашифрованных чатах нельзя отправить жалобу или оценить ответ. Это необходимо для полного обеспечения конфиденциальности вашей переписки',
      EMPTY_RESPONSE: 'Произошла ошибка в запросе, пожалуйста, попробуйте еще раз',
      RETRY: 'Повторить',
    },
    TEXT_TO_SPEECH_ERROR:
      'Мы не смогли получить доступ к вашему микрофону. Пожалуйста, проверьте разрешения браузера или устройства, чтобы включить преобразование речи в текст.',
    PASSWORD_CHANGED: 'Пароль успешно изменён',
    FAILED_TO_LOAD_IMAGE: 'Не удалось загрузить изображение!',
    COPIED_TO_CLIPBOARD: 'Скопировано в буфер обмена',
  },
  COMMON: {
    ADD: 'Добавить',
    OR: 'или',
    AND: 'и',
    BY: 'от',
    FREE: 'БЕСПЛАТНО',
    EXAMPLE: 'Пример',
    CONTINUE: 'Продолжить',
    CONFIRM: 'Подтвердить',
    SUBMIT: 'Отправить',
    DELETE: 'Удалить',
    DELETED: 'Удалено',
    SAVE: 'Сохранить',
    DONE: 'Готово',
    REGENERATE: 'Сгенерировать снова',
    GENERATE: 'Сгенерировать',
    GENERATING: 'Генерация',
    GENERATION: 'Генерация...',
    REFILL_BALANCE: 'Пополнить баланс',
    DISCOUNT: '{{percent}}% Скидка',
    CREATE: 'Создать',
    CANCEL: 'Отмена',
    COPY: 'Копировать',
    COPIED: 'Скопировано',
    BACK: 'Назад',
    LOG_IN: 'Войти',
    SIGN_IN: 'Авторизоваться',
    SIGN_UP: 'Зарегистрироваться',
    SIGN_UP_WITH: 'Регистрация через {{ provider }}',
    PASSWORD: 'Пароль',
    CONFIRM_PASSWORD: 'Подтвердите пароль',
    NOT_AVAILABLE: 'Недоступно',
    CLOSE: 'Закрыть',
    PAUSE: 'Пауза',
    PLAY: 'Воспроизвести',
    STOP: 'Остановить',
    MIN: 'Мин',
    MAX: 'Макс',
    WARNING: 'Предупреждение',
    INFO: 'Информация',
    ERROR: 'Ошибка',
    SUCCESS: 'Успех',
    APPLIED: 'Применено',
    START: 'Старт',
    LOADING: 'Загрузка...',
    PLACEHOLDER: {
      SEARCH: 'Поиск...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'Файл {{fileName}} имеет недопустимый тип. Разрешённые типы: {{allowedTypes}}',
      INVALID_FILE_TYPE_SHORT: 'Разрешены: {{allowedTypes}}',
      MAX_FILE_SIZE: 'Файл {{fileName}} должен быть меньше {{maxSize}}МБ',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Перетащите или нажмите, чтобы загрузить изображение',
      DROP_FILE: 'Перетащите файл сюда',
      CHOOSE_FILE: 'Выбрать файл',
    },

    ERRORS: {
      INVALID_FIELD: 'Поле недействительно',
      FILLED_IN: 'Поле должно быть заполнено',
      MIN_LENGTH: 'Минимальная длина — {{length}} символов',
      MAX_LENGTH: 'Максимальная длина — {{length}} символов',
      NO_SPACES: 'Поле не может начинаться, заканчиваться или состоять только из пробелов',
      INVALID_EMAIL: 'Неверный адрес электронной почты',
      INVALID_CURRENT_PASSWORD: 'Текущий пароль недействителен',
      PASS_NOT_CHANGED: 'Новый пароль должен отличаться от старого.',
      INVALID_USERNAME: 'Неверное имя пользователя',
      INVALID_USERNAME_EXPANDED:
        'Имя пользователя должно быть от 3 до 20 символов и может содержать только латинские буквы (a–z), цифры и дефисы',
      DUMB_ERROR: 'Что-то пошло не так',
      PASSWORD_MISMATCH: 'Пароли не совпадают',
      INVALID_PASSWORD:
        'Длина пароля должна быть от {{minLength}} до {{maxLength}} символов. Допустимы только A-Z, a-z, 0-9 и специальные символы.',
      INVALID_PASS: 'Неверный пароль',
      INVALID_EMAIL_OR_PASSWORD: 'Неверная почта или пароль',
      FIELD_BETWEEN: 'Длина должна быть от {{minLength}} до {{maxLength}} символов.',
      VALUE_MUST_BE_BETWEEN: 'Значение должно быть между {{min}} и {{max}}',
      LOADING_ERROR: 'Ошибка загрузки',
      NOT_ENOUGH_TOKENS: 'У вас недостаточно токенов для генерации изображения. Пожалуйста, пополните свой аккаунт.',
      NO_ITEMS_AVAILABLE: 'Нет доступных элементов',
      SPEECH_RECOGNITION_NOT_SUPPORTED: 'API распознавания речи не поддерживается в этом браузере.',
    },
    MONTH: {
      JANUARY: 'Январь',
      FEBRUARY: 'Февраль',
      MARCH: 'Март',
      APRIL: 'Апрель',
      MAY: 'Май',
      JUNE: 'Июнь',
      JULY: 'Июль',
      AUGUST: 'Август',
      SEPTEMBER: 'Сентябрь',
      OCTOBER: 'Октябрь',
      NOVEMBER: 'Ноябрь',
      DECEMBER: 'Декабрь',
    },
    WEEK: {
      MONDAY: 'Пн',
      TUESDAY: 'Вт',
      WEDNESDAY: 'Ср',
      THURSDAY: 'Чт',
      FRIDAY: 'Пт',
      SATURDAY: 'Сб',
      SUNDAY: 'Вс',
    },
    SHOW: 'Показать',
    HIDE: 'Скрыть',
    DISABLE: 'Отключить',
    ENABLE: 'Включить',
    DENY: 'Запретить',
    ALLOW: 'Разрешить',
    MORE: 'Больше',
    LESS: 'Меньше',
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'Как работает смена  плана подписки?',
      ANSWER:
        'Смена плана подписки доступна в любой момент: При переходе на уровень выше — активация происходит сразу после оплаты разницы за оставшееся время. При переходе на ниже — активация произойдет после окончания текущего периода.',
    },
    TOPIC2: {
      QUESTION: 'Сгорают ли бонусная энергия после окончания подписки?',
      ANSWER:
        'Нет, бонусная энергия не сгорает — вы можете продолжать использовать ее даже после окончания подписки. Когда вы оформите новую подписку, вам будет начислена новая порция бонусной энергии.',
    },
    TOPIC3: {
      QUESTION: 'Продлевается ли подписка автоматически?',
      ANSWER:
        'Да, подписка продлевается автоматически для вашего удобства, чтобы вы не теряли доступ к функциям. Но вы можете отменить автопродление в любой момент через настройки. При этом доступ к возможностям подписки сохранится до конца оплаченного периода.',
    },
    TOPIC4: {
      QUESTION: 'Остались еще вопросы?',
      ANSWER: 'Если вам нужна помощь, свяжитесь с нашей службой поддержки по адресу {{email}}.',
      BUTTON: 'Задать вопрос в Discord',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Могу ли я изменить свой тарифный план (улучшить или понизить)?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'Как отменить мой тарифный план?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Могу ли я отменить подписку, но сохранить преимущества тарифа до конца текущего расчетного периода?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'Как получить возврат средств?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'У меня есть дополнительные вопросы.',
      ANSWER: 'Если вам нужна помощь, нажмите кнопку ниже. Наша служба поддержки всегда готова помочь.',
      BUTTON: 'Задать вопрос',
    },
  },
  OAUTH_CANNOT_DISCONNECT_LAST_ACCOUNT:
    'Невозможно отключить последний привязанный аккаунт. Хотя бы один аккаунт должен оставаться подключенным.',
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Неверный пароль',
    SLUG_ALREADY_TAKEN: 'Имя пользователя {{slug}} уже занято другим пользователем',
    TOKENS_EXCEEDED:
      'Выбранная модель недоступна для этого персонажа. Бесплатные модели заблокированы для этого персонажа. Общий контекст ({{number}} токенов) превышает лимит (5000). Пожалуйста, используйте платную модель.',
    NOT_ENOUGH_TOKENS: 'У вас недостаточно токенов для генерации этого изображения',
    ALREADY_REPORT_USER: 'Вы уже пожаловались на этого пользователя',
    PAYMENT_PROVIDER: {
      NO_PAYMENT_SYSTEMS: 'Ошибка платежного провайдера: Нет доступных платежных систем',
      BETATRANSFER_ERROR: 'Ошибка платежного провайдера: Неизвестная ошибка от BetaTransfer',
    },
    CANNOT_CREATE_CHAT_WITH_PAID_MODEL:
      'Невозможно создать чат с платной моделью. Для использования платных моделей вам нужны токены или активная платная подписка.',
    TRANSACTION_ID_NOT_FOUND: 'Транзакция с ID {{id}} не найдена',
  },
  SEO: {
    HOME_TITLE: 'Девушка ИИ: Переписка с аниме тянкой (Чарактер АИ) без цензуры',
    HOME_DESCRIPTION:
      'Общайтесь с виртуальной девушкой в формате переписки или создавайте собственных персонажей ИИ. Аниме чат с реалистическими диалогами без цензуры и фильтра онлайн.',

    CATALOG_TITLE: 'Каталог персонажей ИИ: Общение с аниме персонажами в Спайси чате',
    CATALOG_DESCRIPTION:
      'Просматривайте каталог персонажей ИИ и начинайте общение онлайн. Аниме персонажи и уникальные характеры для реалистичных диалогов.',

    SUBSCRIBE_TITLE: 'Подписка и токены: Премиум тарифы CAICHAT',
    SUBSCRIBE_DESCRIPTION:
      'Выберите тарифный план или купите токены для доступа к премиум-функциям. Сравните возможности подписки и улучшите свой опыт общения.',

    HELP_TITLE: 'Помощь и руководство: Поддержка CAICHAT',
    HELP_DESCRIPTION:
      'Инструкции и советы по работе с CAICHAT. Узнайте, как настроить профиль, создавать персонажей, использовать токены и управлять параметрами чата.',

    TERMS_TITLE: 'Пользовательское соглашение — CAICHAT',
    TERMS_DESCRIPTION:
      'Ознакомьтесь с условиями использования CAICHAT, правами и обязанностями пользователей, а также юридической информацией.',

    PRIVACY_TITLE: 'Политика конфиденциальности — CAICHAT',
    PRIVACY_DESCRIPTION: 'Узнайте, как CAICHAT собирает, использует и защищает персональные данные пользователей.',

    REFUND_TITLE: 'Политика возврата средств — CAICHAT',
    REFUND_DESCRIPTION: 'Ознакомьтесь с условиями возврата средств и порядком подачи запроса на возврат подписки или токенов.',

    BLOCKED_CONTENT_TITLE: 'Политика ограниченного контента — CAICHAT',
    BLOCKED_CONTENT_DESCRIPTION: 'Узнайте, какие типы контента ограничены или запрещены на платформе CAICHAT.',

    COMMUNITY_TITLE: 'Правила сообщества — CAICHAT',
    COMMUNITY_DESCRIPTION: 'Ознакомьтесь с правилами сообщества CAICHAT и стандартами допустимого поведения.',

    CONTENT_REMOVAL_TITLE: 'Политика удаления контента — CAICHAT',
    CONTENT_REMOVAL_DESCRIPTION: 'Узнайте, как CAICHAT рассматривает запросы на удаление пользовательского контента.',

    UNDERAGE_TITLE: 'Политика защиты несовершеннолетних — CAICHAT',
    UNDERAGE_DESCRIPTION: 'Ознакомьтесь с возрастными требованиями и мерами защиты несовершеннолетних на платформе CAICHAT.',
  },
};
